import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import api from '../../api';
import DashboardLayout from './DashboardLayout';

function CreateArticle({ onSuccess }) {
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    title: '',
    content: '',
    category: '',
    image: null,
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleFile = e => {
    setForm(prev => ({ ...prev, image: e.target.files[0] }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    data.append('title', form.title);
    data.append('content', form.content);
    data.append('category', form.category);
    if (form.image) data.append('mainImage', form.image);

    try {
      await api.post('/articles', data);
      toast.success('Article created successfully!');
      setForm({ title: '', content: '', category: '', image: null });
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error('Error creating article:', err);
      const errorMsg = err.response?.data?.error || 'Error creating article. Please try again.';
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <form onSubmit={handleSubmit} className="max-w-xl mx-auto p-4 border rounded shadow mb-6">
        <h2 className="text-xl font-bold mb-4">Create New Article</h2>

        <input
          type="text"
          name="title"
          value={form.title}
          onChange={handleChange}
          placeholder="Title"
          className="w-full p-2 mb-2 border"
          required
          disabled={loading}
        />

        <textarea
          name="content"
          value={form.content}
          onChange={handleChange}
          placeholder="Write content (can include multiple paragraphs)..."
          className="w-full p-2 mb-2 border h-40"
          required
          disabled={loading}
        />

        <input
          type="text"
          name="category"
          value={form.category}
          onChange={handleChange}
          placeholder="Category"
          className="w-full p-2 mb-2 border"
          required
          disabled={loading}
        />

        <div className="mb-2">
          <label>Main Image:</label>
          <input type="file" onChange={handleFile} disabled={loading} />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-black px-4 py-2 rounded"
          disabled={loading}
        >
          {loading ? 'Publishing...' : 'Publish Article'}
        </button>
      </form>
    </DashboardLayout>
  );
}

CreateArticle.propTypes = {
  onSuccess: PropTypes.func,
};

export default CreateArticle;
